import React__default from 'react';
import { dataViewSize } from '@keepeek/commons';
import { LinearProgress } from '@mui/material';
import { useRecoilValue } from 'recoil';
import ElementSummary from '../../../ElementSummary/index.js';
import { KGridMode } from '../../KGrid/index.js';

var MasonryDataViewLoading = function (_a) {
    var KGrid = _a.KGrid, dataViewKey = _a.dataViewKey;
    var size = useRecoilValue(dataViewSize(dataViewKey));
    var randomHeight = function () { return "".concat(Math.floor(Math.random() * (500 - 100 + 1) + 100), "px"); };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(LinearProgress, { color: "primary" }),
        React__default.createElement(KGrid, { id: "MasonryDataView", mode: KGridMode.Masonry, className: "MasonryDataView-KGrid-loading" }, Array(size)
            .fill(null)
            .map(function (_p, i) { return (React__default.createElement("li", { key: i },
            React__default.createElement(ElementSummary, { sx: { height: randomHeight() }, loading: true, className: "MasonryDataView-ElementSummary-loading" }))); }))));
};

export { MasonryDataViewLoading };
//# sourceMappingURL=MasonryDataViewLoading.js.map
